import React from 'react';
import { BaseSelector, BaseSelectorProps } from '../base/base-selector';
import styles from './font.module.scss';

export interface Props extends BaseSelectorProps {
  /**
   * default selected option
   * @default ''
   */
  selectedOption?: string;
  /**
   * default header text to show
   * @default 'Aa'
   */
  selectedOptionText?: string;
}

type FontProps = Omit<Props, 'children'>;

const FontRenderer = (selectedOption: string, backgroundColor: any, selectedOptionText = 'Aa') => (
  <div className={styles.selectContainer}>
    <span style={{ color: selectedOption }}>{selectedOptionText}</span>
    <div className={styles.fontColorIndicator} style={backgroundColor} />
  </div>
);
export const Font = ({ selectedOption, selectedOptionText, ...restProps }: FontProps) => {
  const backgroundColor = { backgroundColor: selectedOption };
  return (
    <>
      <BaseSelector {...restProps}>
        {FontRenderer(selectedOption!, backgroundColor as any, selectedOptionText)}
      </BaseSelector>
    </>
  );
};
